<!-- AÑADIR CLASE hideLogo CUANDO ESTÉ GRABANDO  -->
<div class="header" [ngClass]="{'hideLogo': recording}">
    <div class="header__logo">
        <img src="assets/img/diseno/logo.png" />
    </div>
    <div class="header__logo responsive">
        <img src="assets/img/diseno/logo-sm.png" />
    </div>
    <div class="user-counter" >
      @if(showIconUser && features.participants_number){
        <div class="user-counter-number" (click)="showUserList()">
            <div class="user-counter-inner" >
                <div class="user-counter-text" translate="HEADER.USERS"></div>
                <div class="user-counter-data">
                    {{participants}}
                </div>
            </div>
            <img src="assets/img/diseno/user.png">
            <!-- <i class="icon-user" ></i> -->
        </div>
      }
      <!-- SUPPORT PHONE -->
      <div class="waiting-room-support">
      <!-- SUPPORT DESKTOP -->
          <div class="content">
            <p class="text" [translate]="'HEADER.TECHNICAL_SUPPORT'"></p>
            <p class="number">{{supportPhone}}</p>
          </div>
          <div class="icon-desktop">
            <i class="icon-call_blue"></i>
          </div>
      <!-- BOTTON MOBILE SUPPORT MOBILE -->
          <div class="support-mobile-btn more-btn" >			
            <div class="suppor-icon" (click)="showSupportNumber()">
              <i class="icon-call_blue"></i>
              <p class="text"  translate="HEADER.TECHNICAL_SUPPORT"></p>
            </div>
            <!-- CONTAINER TELÉFONO SOPORTE TOOLTIP -->
            <div class="support-number-container box-content">
              <sas-support-tooltip></sas-support-tooltip>
            </div>
            <!-- @if(!hide){
              <div class="box-content" >
                <p class="text"  translate="HEADER.TECHNICAL_SUPPORT"></p>
                <a href="tel:+{{supportPhone}}" class="number">{{supportPhone}}</a>
              </div>
            } -->
          </div>
      </div>
    </div>   
</div>
